import apiClient from "../api/apiClient";

const groupService = {
  // Service to create group nodes
  createGroupNodes: async (nodes, startNode, nameRequired) => {
    try {
      const response = await apiClient.post("/create/group-nodes", {
        nodes,
        start_node: startNode,
        name_required: nameRequired,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to create group nodes: ${error.message}`);
    }
  },

  // Service to search graph data
  searchGraphData: async (userId, includeIds = [], includeKeywords = []) => {
    try {
      const response = await apiClient.post(`/graph/search/${userId}/`, {
        includeClasses: [],
        includeTopics: [],
        includeKeywords: includeKeywords,
        includeManualAndExpand: [],
        includeIds: includeIds,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch graph data: ${error.message}`);
    }
  },
  // Service to fetch group data
  fetchGroupData: async (groupName) => {
    try {
      const response = await apiClient.post("/group/fetch", {
        name: groupName,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch group data: ${error.message}`);
    }
  },

  deleteGroup: async (groupName) => {
    try {
      const data = { name: groupName };
      const response = await apiClient.post("/group/delete", data);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to delete group: ${error.message}`);
    }
  },

  deleteCustomSearch: async (searchName) => {
    try {
      const data = { id: searchName };
      const response = await apiClient.post("/custom_search/delete", data);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to delete custom search: ${error.message}`);
    }
  },

  updateSavedSearch: async (searchId, searchName, comment, link) => {
    try {
      const response = await apiClient.post("/custom_search/update", {
        id: searchId,
        name: searchName,
        comment: comment,
        link: link,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to update saved search: ${error.message}`);
    }
  },

  saveSearch: async (userId, searchName, comment, link, rulesForJson) => {
    try {
      const response = await apiClient.post("/custom_search", {
        name: searchName,
        // rules: JSON.stringify(rulesForJson),
        user_id: userId,
        comments: comment,
        link: link,
        rules: JSON.stringify(rulesForJson),
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to save search: ${error.message}`);
    }
  },
  exportGroup: async (payload) => {
    const response = await apiClient.post("/export-group", payload);
    return response;
  },
};

export default groupService;
